/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function PersonalBanner() {
    
    return (
        <>

            
		<div className="banner">
            <img
                src='../../assets/images/Personal.jpg'
                 alt="Personal Virtual Assistant for Task Support - ConnectMyVA"
                    title="Delegate Personal Tasks to Virtual Assistants - ConnectMyVA"
                className="bannerImage"
            />			
        </div>
            

        </>
    )
}

export default PersonalBanner
